import { createContext } from 'react';

// Меню и просмотр изображений остаются внутри фокуса быстрой модалки.
// На странице чатов null сохраняет прежний portal в document.body.
export const ChatOverlayRoot = createContext(null);